"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _react = require("react");
var _framerMotion = require("framer-motion");
var _reactLaag = require("react-laag");
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const DEFAULT_OPTIONS = {
  auto: true,
  overflowContainer: false,
  placement: 'bottom-end'
};
const Popover = _ref => {
  let {
    trigger,
    content,
    isShowing,
    hideOnOutsideClick,
    hideOnContentClick,
    hideOnContentItemClick,
    hideOnDisappear,
    options,
    onToggle
  } = _ref;
  const [isOpen, setIsOpen] = (0, _react.useState)(isShowing || false);
  const onClick = () => {
    const open = !isOpen;
    setIsOpen(open);
    if (onToggle) {
      onToggle(open);
    }
  };
  const onEscapePress = evt => {
    if (evt.key === 'Escape' && isOpen) {
      onClick();
    }
  };
  (0, _react.useEffect)(() => {
    if (isOpen) {
      document.addEventListener('keydown', onEscapePress);
      return () => {
        document.removeEventListener('keydown', onEscapePress);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);
  const onOutsideClick = () => {
    if (hideOnOutsideClick) {
      onClick();
    }
    if (options !== null && options !== void 0 && options.onOutsideClick) {
      options.onOutsideClick();
    }
  };
  const onDisappear = () => {
    if (hideOnDisappear) {
      onClick();
    }
    if (options !== null && options !== void 0 && options.onDisappear) {
      options.onDisappear();
    }
  };
  const {
    renderLayer,
    triggerProps,
    layerProps
  } = (0, _reactLaag.useLayer)(_objectSpread(_objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options), {}, {
    isOpen,
    onOutsideClick,
    onDisappear
  }));
  const onContentClick = evt => {
    if (hideOnContentClick || hideOnContentItemClick !== null && hideOnContentItemClick !== void 0 && hideOnContentItemClick.includes(evt.target.id)) {
      onClick();
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_framerMotion.LazyMotion, {
      features: _framerMotion.domAnimation,
      children: [/*#__PURE__*/(0, _react.cloneElement)(trigger, _objectSpread(_objectSpread({}, triggerProps), {}, {
        'aria-expanded': isOpen,
        onClick
      })), renderLayer( /*#__PURE__*/(0, _jsxRuntime.jsx)(_framerMotion.AnimatePresence, {
        children: isOpen && /*#__PURE__*/(0, _jsxRuntime.jsx)(_framerMotion.m.div, _objectSpread(_objectSpread({
          initial: "collapsed",
          animate: "open",
          exit: "collapsed",
          variants: {
            open: {
              opacity: 1,
              scale: 1
            },
            collapsed: {
              opacity: 0,
              scale: 0.85
            }
          },
          transition: {
            type: 'spring',
            stiffness: 800,
            damping: 35
          }
        }, layerProps), {}, {
          onClick: onContentClick,
          onKeyDown: evt => evt.key === 'Enter' ? onContentClick(evt) : null,
          children: content
        }))
      }))]
    })
  });
};
Popover.defaultProps = {
  hideOnOutsideClick: true
};
var _default = exports.default = Popover;